module.exports = __webpack_public_path__ + "img/danger.56508ac3.svg";